import { render, staticRenderFns } from "./PoliciesPopup.vue?vue&type=template&id=21840cba&scoped=true&"
import script from "./PoliciesPopup.vue?vue&type=script&lang=js&"
export * from "./PoliciesPopup.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesPopup.vue?vue&type=style&index=0&id=21840cba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21840cba",
  null
  
)

export default component.exports